<script lang="ts">
	import { push, replace as spaReplace } from "svelte-spa-router";
	import { onMount } from "svelte";

	export let to: string;
	export let replace = false;

	onMount(() => {
		if (replace) {
			spaReplace(to);
		} else {
			push(to);
		}
	});
</script>
